/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Bot_Auto_ApplyInputs */

const tr_landing_pricerules_mock_bot_auto_apply = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Auto_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiç sormadan uygula`)
};

const en_landing_pricerules_mock_bot_auto_apply = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Auto_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply without asking`)
};

const de_landing_pricerules_mock_bot_auto_apply = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Auto_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Rückfrage anwenden`)
};

const ru_landing_pricerules_mock_bot_auto_apply = /** @type {(inputs: Landing_Pricerules_Mock_Bot_Auto_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применять без подтверждения`)
};

/**
* | output |
* | --- |
* | "Apply without asking" |
*
* @param {Landing_Pricerules_Mock_Bot_Auto_ApplyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_bot_auto_apply = /** @type {((inputs?: Landing_Pricerules_Mock_Bot_Auto_ApplyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Bot_Auto_ApplyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_bot_auto_apply(inputs)
	if (locale === "de") return de_landing_pricerules_mock_bot_auto_apply(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_bot_auto_apply(inputs)
	return tr_landing_pricerules_mock_bot_auto_apply(inputs)
});